<template>
  <div class="go-in">
    <banner img="../assets/img/bgtop.jpg" title="Cost Optimization" />
    <div class="section" v-loading="loading">
      <div class="section-content">

        <!-- Section 1 -->
        <div class="content-summary">
          <div class="summary-left">
            <p class="eTitle">Cost Optimization</p>
            <p class="content">
              Lower costs brought about by optimizing components: With the advancement of science and technology and changing patterns of market competition, more and more engineers and manufacturers choose to optimize component materials to achieve the objective of improving R&D efficiency and increasing enterprise competitiveness. Therefore, using only first-tier brands can no longer meet the demand. According to customer's products, providing more diverse brand choices, lower prices, and stable quality components has always been the core competition of our enterprise.
            </p>
          </div>

          <div class="summary-right">
            <img src="../assets/img/GD.png" alt="Company Overview" />
            <img src="../assets/img/UMW.png" alt="Company Overview" />
            <img src="../assets/img/YXC.jpg" alt="Company Overview" />
            <img src="../assets/img/风华高科.jpg" alt="Company Overview" />
            <img src="../assets/img/宏发.jpg" alt="Company Overview" />
            <img src="../assets/img/上海贝岭.jpg" alt="Company Overview" />
            <img src="../assets/img/长电科技.jpg" alt="Company Overview" />
          </div>
        </div>

        <!-- Section 2 -->
        <div class="content-summary1">
          <div class="summary-left">
            <p class="content">
              Provide ODM and OEM services: From the Internet to artificial intelligence, it drives more enterprises with missions and ideals of entrepreneurs are fully committed to this change. Low MOQ, stable delivery time, strong technical team support. We will have a strong backing for customers and will escort all the way!
            </p>
          </div>

          <div class="summary-right">
            <img src="../assets/img/1731378730112  2段下 (1).png" alt="Company Overview" />
            <img src="../assets/img/1731378730112  2段下 (2).png" alt="Company Overview" />
            <img src="../assets/img/1731378730112  2段下 (3).png" alt="Company Overview" />
          </div>
        </div>

        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>

        <!-- Section 3: Culture -->
        <div class="content-culture">
          <span>
            Convenient payment: Strife and turmoil are no longer stumbling blocks to restrict trade and commerce. Our products come from the USA, Japan, China, and other countries, and are also exported to India, Brazil, and the European Union. Apart from bank transfers, payment methods are also supported through cryptocurrencies. Wherever the customer is, cooperation is achieved and we will achieve the mission!
          </span>
        </div>

        <div class="summary-right">
          <img src="../assets/img/1731389426647 3段下.png" alt="Company Overview" />
          <img src="../assets/img/1731390193022 3段下.png" alt="Company Overview" />
          <img src="../assets/img/1731390242880 3段下.png" alt="Company Overview" />
        </div>

        <!-- Company Honors -->
        <div class="content-honor">
          <div class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
              <!-- 可以直接绑定本地图片 -->
              <img v-lazy="'../assets/img/honor1.png'" alt="Honor Image" />
            </el-dialog>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: false, // 直接显示
      dialogTableVisible: false,
      dialogUrl: "../assets/img/honor1.png",
      dialogTitle: "Company Honor"
    };
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  background-color: #14679f;

  .section {
    width: 100%;
    padding: 20px 0;
    background-color: #fff;

    &-content {
      width: 90%;
      max-width: 1240px;
      margin: 0 auto;
 .content-summary1 {
        display: blocks;
        justify-content: space-between;
        align-items: flex-start;
        padding: 50px 0;

        .summary-left {
          width: 100%;
          .eTitle {
            font-size: 24px;
            color: #e13834;
          }
         .content {
  background-color: #f0f4f8;
  padding: 15px;
  border-radius: 8px;
  color: #333;
  line-height: 1.8;
  text-indent: 25px;
}

        }
        
.summary-left {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}

        .summary-right {
          img {
            width: auto;
            height: auto;
          }
        }
      }

      .content-summary {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 50px 0;

        .summary-left {
          width: 100%;
          .eTitle {
            font-size: 24px;
            color: #e13834;
          }
         .content {
  background-color: #f0f4f8;
  padding: 15px;
  border-radius: 8px;
  color: #333;
  line-height: 1.8;
  text-indent: 25px;
}

        }
        
.summary-left {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}

        .summary-right {
          img {
            width: auto;
            height: auto;
          }
        }
      }

     .content-culture {
  padding: 40px;
  background: linear-gradient(135deg, #ffe6cc, #ffcc99); // 明亮渐变背景
  border-radius: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-align: justify; // 调整文字为两端对齐
  position: relative;

  // 添加顶部波浪装饰
  &::before {
    content: "";
    position: absolute;
    top: -20px;
    left: 0;
    width: 100%;
    height: 20px;
    
  }

  // 添加底部波浪装饰
  &::after {
    content: "";
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 100%;
    height: 20px;
  
  }

  span {
    font-size: 18px; // 更大的文字
    font-family: "Georgia", serif; // 替换为衬线字体
    line-height: 1.8;
    color: #7d4f2f; // 柔和的棕色
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); // 为文字添加阴影效果
  }
}


      .content-honor {
        padding: 50px 0;
        .honor-big-img {
          width: 100%;
          height: auto;

          .el-dialog__wrapper {
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
.eTitle {
  font-size: 24px;
  font-weight: bold;
  color: #14679f;
  position: relative;
}

.eTitle::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 50px;
  height: 3px;
  background-color: #e13834;
  border-radius: 2px;
}

.el-divider-active {
  background-color: #3c6088;
  height: 3px;
}

.top {
  text-align: center;
  color: #3c6088;

  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
.summary-right {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;

  img {
    width: 280px;
    height: 180px;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  img:hover {
    transform: scale(1.05); /* 悬浮效果，图片放大 */
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2); /* 鼠标悬停时增加阴影 */
  }
}

</style>
